export default __webpack_public_path__ + "static/media/logo-wayun.667ac9fc.png";